import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/dashboard/Sidebar';

const titles = {
  '/dashboard': { title: 'Dashboard', desc: 'Pre-shipment review across your active shipments.' },
  '/shipments': { title: 'Shipments', desc: 'All registered shipments and their compliance state.' },
  '/reports': { title: 'Reports', desc: 'Audit-ready compliance summaries.' },
  '/admin': { title: 'Admin', desc: 'Workspace, members and integrations.' },
  '/settings': { title: 'Settings', desc: 'Profile and workspace preferences.' },
};

export default function AppLayout() {
  const location = useLocation();
  const meta = Object.entries(titles).find(([k]) => location.pathname.startsWith(k))?.[1];

  return (
    <div className="min-h-screen bg-navy-950 text-white flex">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <div className="border-b border-white/5 bg-navy-900/30 backdrop-blur-sm">
          <div className="max-w-screen-2xl mx-auto px-6 md:px-10 py-6">
            <div className="text-[10px] uppercase tracking-widest text-cyan-glow font-mono mb-2">Pre-shipment review</div>
            <h1 className="font-display text-2xl md:text-3xl font-bold tracking-tight" data-testid="page-title">
              {meta?.title || 'Workspace'}
            </h1>
            {meta?.desc && (
              <p className="text-sm text-slate-400 mt-1.5">{meta.desc}</p>
            )}
          </div>
        </div>
        <div className="max-w-screen-2xl mx-auto px-6 md:px-10 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
